import React from 'react';

const ProductResultsContext = React.createContext({});

export { ProductResultsContext };
